import ComprasPorMotivoAdjudicacion from './ComprasPorMotivoAdjudicacionContainer';

export default ComprasPorMotivoAdjudicacion;
